export const CALENDAR_PERIODS = {
  ANY_DATE: "any_date",
  TODAY: "today",
  THIS_WEEK: "this_week",
  THIS_MONTH: "this_month",
};

export const CALENDAR_VIEWS = {
  DAY: "day",
  WEEK: "week",
};

export const DYNAMIC_TIMEZONE_OPTIONS = {
  APP: "app",
  USER: "user",
};
